import React, { useEffect, useState } from 'react';
import { Settings2 } from 'lucide-react';
import DashboardCarousels from './DashboardCarousels';
import DashboardEditor from './DashboardEditor';
import useDashboardSections from '../hooks/useDashboardSections';
import { saveDashboardLayout } from '../utils/dashboardLayout';

// Owns the home dashboard: loads the user's layout, renders the carousels,
// and (for signed-in users) provides a Customize edit mode that persists
// changes via the preferences API.
export default function DashboardManager({ apiBase, isAuthenticated, token }) {
  const loaded = useDashboardSections({ apiBase, isAuthenticated, token });
  const [sections, setSections] = useState(loaded);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // Sync when the loaded layout changes (e.g. after auth resolves).
  useEffect(() => { setSections(loaded); }, [loaded]);

  const handleSave = async (next) => {
    setSaving(true);
    setError(null);
    const ok = await saveDashboardLayout({ apiBase, token, isAuthenticated, sections: next });
    setSaving(false);
    if (ok) {
      setSections(next);
      setEditing(false);
    } else {
      setError('Could not save your layout. Please try again.');
    }
  };

  if (editing) {
    return (
      <>
        {error && (
          <p className="max-w-3xl mx-auto px-4 pt-4 text-sm text-red-600">{error}</p>
        )}
        <DashboardEditor
          initialSections={sections}
          onSave={handleSave}
          onCancel={() => { setEditing(false); setError(null); }}
          saving={saving}
        />
      </>
    );
  }

  return (
    <>
      {isAuthenticated && (
        <div className="max-w-6xl mx-auto px-4 pt-6 flex justify-end">
          <button
            onClick={() => setEditing(true)}
          className="text-sm text-videbits-600 hover:text-videbits-800 flex items-center gap-1"
          >
            <Settings2 className="w-4 h-4" /> Customize
          </button>
        </div>
      )}
      <DashboardCarousels apiBase={apiBase} sections={sections} token={token} />
    </>
  );
}
